import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { SepaQrTileData } from "@modules/main/components/sepa-qr-new/sepa-qr-tile-new/models/sepa-qr-tile-data.model";

@Component({
	selector: "sepa-qr-tile-new",
	templateUrl: "./sepa-qr-tile-new.component.html",
	styleUrls: ["./sepa-qr-tile-new.component.scss"],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false
})
export class SepaQrTileNewComponent {
	@Input() tiles: SepaQrTileData[];
}
